module.exports = __webpack_public_path__ + "static/media/pin-light.9605307e.png";